var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'guide-text-container',
        {
            displayCopy: _vm.displayCopy
        }
    ]},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.parseText)}}),_vm._v(" "),(_vm.displayCopy)?_c('a',{staticClass:"copy",on:{"click":function($event){return _vm.$emit('copy', _vm.parseText)}}},[_vm._v(_vm._s(_vm._lang('copy')))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }